import { ApiV1Response, http } from '../http'

export interface EarnsTodayTradeResponse {
  [userId: string]: number // {"264234": 0}
}

export async function getEarnsTodayTrade<
  T extends ApiV1Response<EarnsTodayTradeResponse>,
>(): Promise<T> {
  return http.get(`/earns/today/trade`).then((r) => r.data)
}
